var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-dropdown"},[_c('div',{staticClass:"header",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_c('div',{staticClass:"header-content-main"},[_vm._t("header",null,{"expanded":_vm.expanded})],2),_c('i',{class:[
        'fa-solid fa-chevron-down fa-2sm',
        { 'fa-solid-open': _vm.expanded }
      ]})]),_c('transition',{attrs:{"name":"list"}},[(_vm.expanded)?_c('ul',[_vm._t("items")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }